import { useTranslation } from 'react-i18next'
import { RecentProductsSlider } from '@components/RecentProductsSlider/RecentProductsSlider'
import { useLiquidSkeleton } from '@velasca/hooks/use-liquid-skeleton'
import { CtaWithBackground } from '@velasca/ui/cta-with-background'
import { SansText } from '@velasca/ui/sans-text'
import { $settings } from '@velasca/utils/globals'
import { CartPageContainer } from '../CartPage.styles'
import { InfoBanner } from '../InfoBanner/InfoBanner'
import { CtaContainer } from './EmptyCart.styles'
import type { EmptyCartProps } from './EmptyCart.types'

export const EmptyCart = ({ emptyCartCtas }: EmptyCartProps) => {
  const { t } = useTranslation('cartDrawer')

  useLiquidSkeleton('.cart-page-skeleton')

  return (
    <>
      <InfoBanner>
        <SansText as="span" size="lg" color="white">
          {t('cart_drawer_empty_cart')}
        </SansText>
      </InfoBanner>

      <CartPageContainer isLoading={false}>
        <CtaContainer>
          {emptyCartCtas.map((cta) => {
            const { image, text, url } = cta

            if (!image) {
              return null
            }

            return (
              <CtaWithBackground
                key={url}
                image={image}
                text={text}
                url={url}
              />
            )
          })}
        </CtaContainer>
      </CartPageContainer>

      {$settings.recentProductsCartEnabled && <RecentProductsSlider />}
    </>
  )
}
